<template>
    <div class="app">
        <app-progress></app-progress>
        <header>Resetting</header>
        <main>
            <router-view/>
        </main>
        <footer></footer>
    </div>
</template>

<script>
    import AppProgress from '@/components/AppProgress';

    export default {
        name: 'App',
        components: {
            AppProgress
        }
    }
</script>
